// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u4bmr","col":"styles_col__3IBN6"};